export default [
  {
    fieldName: 'Name',
    isRequired: true,
    label: 'Jméno',
    type: 'text',
  },
  {
    fieldName: 'Email',
    isRequired: true,
    label: 'E-mail',
    type: 'email',
  },
  {
    fieldName: 'Phone',
    label: 'Telefon',
    type: 'text',
  },
  {
    fieldName: 'Message',
    isRequired: true,
    label: 'Text zprávy',
    type: 'textarea',
  },
];


// WEBPACK FOOTER //
// ./src/formFields/contact.tsx